export default __webpack_public_path__ + "static/media/9.396c1ebc.webp";